import { forwardRef } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

import {
  DIALOG_TITLE_DEFAULTS,
  DIALOG_TYPOGRAPHY_ALIGN_PROPS,
  type TDialogTitleElement,
  type TDialogTitleProps,
} from "@/ui/components/overlay/Dialog/Dialog.config";
import { cn } from "@/ui/lib/utils";
import { TextSubtitle } from "../../typography/TextSubtitle";

export const DialogTitle = forwardRef<TDialogTitleElement, TDialogTitleProps>(
  (
    {
      className,
      children,
      align = DIALOG_TITLE_DEFAULTS.align,
      ...props
    },
    ref,
  ) => (
    <DialogPrimitive.Title
      data-component="DialogTitle"
      ref={ref}
      className={cn(
        "font-sys-heading text-sys-lg leading-sys-1-2 text-foreground",
        className,
      )}
      {...props}
    >
      <TextSubtitle
        tag="span"
        size={3}
        isResponsive={false}
        align={DIALOG_TYPOGRAPHY_ALIGN_PROPS[align]}
        className="block"
      >
        { children }
      </TextSubtitle>
    </DialogPrimitive.Title>
  ),
);

DialogTitle.displayName = DialogPrimitive.Title.displayName;
